import type {BookItem} from '@/types';

/**
 * 时间窗口，该时段内的连续的'涨'或连续的'跌'会忽略
 * @type {number}
 */
const TIME_WINDOW = 450;

export function updateSizePercent(items, total) {
  items.forEach((o) => (o.percent = ((o.total * 100) / total).toFixed(2)));
}

export function updateValuePercent(items: BookItem[], total) {
  items.forEach((o) => (o.percent = ((o.total * 100) / total).toFixed(2)));
}

export function updateSizeStatus(items, now, sizeCache, timeCache, statusCache) {
  items.forEach((o, index) => {
    const {size} = o;
    const lastSize = sizeCache.get(index);
    const lastTime = timeCache.get(index) || 0;
    const currentStatus = statusCache.get(index);
    const nextSizeStatus = calcNextSizeStatus(currentStatus, size - lastSize, TIME_WINDOW > now - lastTime);
    sizeCache.set(index, size);
    if (nextSizeStatus !== currentStatus) {
      statusCache.set(index, nextSizeStatus);
      timeCache.set(index, now);
    }
    o.ss = nextSizeStatus;
  });
}

/**
 * 状态机
 * 0: init, 1: up1, 2: up2, 3: down1, 4: down4
 * @param old
 * @param sd: size differ
 * @param isFlashing: is flashing
 * @returns {number|*}
 */
function calcNextSizeStatus(old, sd, isFlashing) {
  if (old === undefined) {
    return 0;
  }

  if (sd === 0) {
    return old;
  }

  if (isFlashing) {
    if (sd > 0 && (old === 1 || old === 2)) {
      return old;
    }
    if (sd < 0 && (old === 3 || old === 4)) {
      return old;
    }
  }

  if (old === 0) {
    if (sd > 0) {
      return 1;
    }
    if (sd < 0) {
      return 3;
    }
  }

  if (old === 1) {
    if (sd > 0) {
      return 2;
    }
    if (sd < 0) {
      return 3;
    }
  }

  if (old === 2) {
    if (sd > 0) {
      return 1;
    }
    if (sd < 0) {
      return 3;
    }
  }

  if (old === 3) {
    if (sd > 0) {
      return 1;
    }
    if (sd < 0) {
      return 4;
    }
  }

  if (old === 4) {
    if (sd > 0) {
      return 1;
    }
    if (sd < 0) {
      return 3;
    }
  }

  return old;
}
